import State from './State'
import Condition from './Condition'
import ServiceAccess from '../service/ServiceAccess'

export default class Screen {

  constructor (obj) {
    this.id = obj.id
    this.entryPoint = obj['entry-point']
    this.entryPoints = obj['entry-points']
    this.states = {}
    this.leave = obj['leave']
    
    if (obj.states) {
      for (let s of obj.states) {
        let state = new State(s)
        this.states[state.id] = state
      }
    }

  }

  leaveCall (call, sessionId) {
    /*eslint no-unused-vars: "off"*/
    let requestReview = function () {
      return ServiceAccess.instance.requestReview(sessionId)
    }

    /*eslint no-eval: "off"*/
    return eval(call)
  }

  onLeave (values, sessionId) {
    let promises = []
    if (this.leave) {
      for (let l of this.leave) {
        if (Condition.evalCondition(l.condition, values)) {
          let promise = this.leaveCall(l.call, sessionId)
          if (promise instanceof Promise) {
            promises.push(promise)
          }
        }
      }
    }
    return Promise.all(promises)
  }

  entryState (values) {
    let nextStateId = null
    let nextScreenId = null

    if (this.entryPoint) {
      nextStateId = this.entryPoint
    } else if (this.entryPoints) {
      if (!(this.entryPoints instanceof Array)) {
        console.error('EntryPoints are not array - maybe you meant entryPoint (without s) for single entry')
      } 
      for (let ep of this.entryPoints) {
        if (ep.condition != null) {
          if (Condition.evalCondition(ep.condition, values)) {
            if ('target' in ep) {
              nextStateId = ep.target
            } else if ('target-screen' in ep) {
              nextScreenId = ep['target-screen']
            }
            break

          }
        } else {
          if ('target' in ep) {
            nextStateId = ep.target
          } else if ('target-screen' in ep) {
            nextScreenId = ep['target-screen']
          }
          break
        }
      }
    }
    return [nextStateId, nextScreenId]
    
  }


  // --------------------------------------------------------------------------
  statePath (values) {
    let [stateId, screenId] = this.entryState(values)
    if (stateId == null || screenId) {
      return [null, screenId]
    }

    let state = this.states[stateId]
    let statePath = [state]
    let transitionToScreenId = null

    while (true) {
      let v = values[state.qid]

      let [nextStateId, nextScreenId] = state.nextStateIdAndScreenId(v, values)

      if (nextScreenId != null) {
        transitionToScreenId = nextScreenId
        break
      } else if (nextStateId != null) {
        let nextState = this.states[nextStateId]
        statePath.push(nextState)
        state = nextState
      } else {
        break
      }

    }

    return [statePath, transitionToScreenId]
  
  }

}



// WEBPACK FOOTER //
// ./src/model/Screen.js